import { ConsentStatus } from '@remarkable/tracking-browser';
import { initTracker } from '@remarkable/tracking-browser/lib/ampli';

import { CONFIG } from '../config';

if (CONFIG.TrackingAPI === undefined) {
  console.error('TrackingAPI is not defined');
}

export const tracker = initTracker({
  apiEndpoint: CONFIG.TrackingAPI,
  consentStatus: typeof window === 'undefined' ? null : ConsentStatus.CONSENTED,
  // Only set cookieDomain if we are on my.remarkable.com or it's subdomains to unify cookie values
  ...(CONFIG.TrackingCookieDomain &&
  window.location.hostname.includes('remarkable.com')
    ? { cookieDomain: 'remarkable.com' }
    : {}),
});
